import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function signInCourtiersRequest(isLoading) {
  return {
    type: actionsTypesMembers.SIGNIN_COURTIERS_REQUEST,
    isLoading,
  }
}
function signInCourtiersFailure(isError) {
  return {
    type: actionsTypesMembers.SIGNIN_COURTIERS_FAILURE,
    isError,
  }
}
function signInCourtiersSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.SIGNIN_COURTIERS_SUCCESS,
    isSuccess,
  }
}
export function fetchSignInCourtiersAction(courtierData) {
  return function(dispatch, getState) {
    
    dispatch(signInCourtiersRequest(true))

    return backendMembers.loginCourtier(courtierData)
      .then(res => {
        localStorage.setItem('feathers-jwt', res.data.accessToken)
        localStorage.setItem('isCurrentLoginCourtier', true)
        dispatch(signInCourtiersRequest(false))
        dispatch(signInCourtiersSuccess(true))
      })
      .catch(error => {
        dispatch(signInCourtiersRequest(false))
        dispatch(signInCourtiersFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Authentification/SignInCourtiers.js